const styles = theme => ({
  updateAccessContainer: {
    margin: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(1)
    }
  },
  informationContainer: {
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2)
    }
  },
  personalInformation: {
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
      display: "inline",
      width: "100%"
    }
  },
  nameText: {
    fontWeight: 600,
    color: theme.palette.primary.default
  },
  personPicture: {
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto",
      marginBottom: theme.spacing(2)
    }
  },

  personalInformationText: {
    marginLeft: theme.spacing(3),
    fontWeight: "normal",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      marginLeft: 0
    }
  },
  numberEmailAddiotnalFieldsText: {
    color: theme.palette.alt.main
  },
  additionalFieldsTitle: {
    fontWeight: 600,
    color: theme.palette.primary.default
  },
  additionalFields: {
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      textAlign: "center",
      display: "none"
    }
  },
  additionalFieldsPhoneVersion: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      display: "inline",
      marginLeft: 0,
      marginTop: theme.spacing(3)
    }
  },
  rankSquadContainer: {
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center"
    }
  },
  fieldText: {
    color: theme.palette.primary.default
  },
  rankContainer: {
    marginRight: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(8)
    }
  },
  accessContainer: {
    borderTop: "1px solid #CCCCCC",
    [theme.breakpoints.down("sm")]: {
      borderBottom: "1px solid #CCCCCC"
    }
  },
  accessRightsTitle: {
    color: theme.palette.primary.default
  },
  roleContainer: {
    width: "50%",
    paddingRight: theme.spacing(2),
    color: theme.palette.primary.default,
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  roleText: {
    marginLeft: theme.spacing(4),
    color: theme.palette.alt.main
  },
  radioPlacement: {
    flexDirection: "row"
  },
  updateButton: {
    marginLeft: theme.spacing(1)
  },
  removeAccessButton: {
    color: [theme.palette.secondary.main, "!important"],
    marginLeft: theme.spacing(4)
  },
  removeAccessButtonWorking: {
    color: [theme.palette.secondary.main, "!important"],
    opacity: 0.3,
    marginLeft: theme.spacing(4)
  },
  [theme.breakpoints.down("sm")]: {
    marginLeft: theme.spacing(0)
  },
  backButton: {
    color: [theme.palette.primary.default, "!important"]
  },
  buttonsContainer: {
    marginRight: theme.spacing(4),
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(1),
      width: "100%"
    }
  },
  radioColor: {
    color: theme.palette.primary.default
  },

  dialogActions: {
    justifyContent: "inherit"
  },
  buttonProgress: {
    marginLeft: theme.spacing(1)
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/UpdateAccess/styles.js